export default "__VITE_ASSET__51af9626__"